export {
  blenderForeground,
  blenderBackground,
  getBlenderTypographyType,
  getBackgroundBlendOptions,
  getForegroundBlendOptions,
  resolveColor,
} from './blender';

export type { BlenderProps, BlendVariant, BlendMode, BlendIntensity } from './BlenderProps';

export type { OpaqueColorName, ForegroundBlendOptions, BackgroundBlendOptions } from './blendOptions';

export { blenderCss } from './blenderCss';
